import { Module, DynamicModule, Type } from '@nestjs/common';
import {
  CommonModule,
  RequestContextService,
  HTTP_CLIENT_FACTORY,
} from '@lark-apaas/nestjs-common';
import { DebugController, WebhookController } from './controllers';
import {
  CapabilityService,
  PluginLoaderService,
  TemplateEngineService,
  TelemetryService,
  type CapabilityModuleOptions,
} from './services';

const CAPABILITY_OPTIONS = Symbol('CAPABILITY_OPTIONS');

const isDevelopment = process.env.NODE_ENV === 'development';

function getControllers(): Type[] {
  const controllers: Type[] = [WebhookController];
  if (isDevelopment) {
    controllers.push(DebugController);
  }
  return controllers;
}

@Module({
  imports: [CommonModule],
  controllers: getControllers(),
  providers: [CapabilityService, PluginLoaderService, TemplateEngineService, TelemetryService],
  exports: [CapabilityService, TelemetryService],
})
export class CapabilityModule {
  static forRoot(options?: CapabilityModuleOptions): DynamicModule {
    return {
      module: CapabilityModule,
      imports: [CommonModule],
      controllers: getControllers(),
      providers: [
        {
          provide: CAPABILITY_OPTIONS,
          useValue: options ?? {},
        },
        {
          provide: CapabilityService,
          useFactory: (
            requestContextService: RequestContextService,
            httpClientFactory: any,
            pluginLoader: PluginLoaderService,
            templateEngine: TemplateEngineService,
            telemetryService: TelemetryService,
            moduleOptions: CapabilityModuleOptions,
          ) => {
            const service = new CapabilityService(
              requestContextService,
              httpClientFactory,
              pluginLoader,
              templateEngine,
              telemetryService,
            );
            // 设置模块配置（包括 capabilitiesDir、enableWatching、watchDebounce）
            if (moduleOptions) {
              service.setOptions(moduleOptions);
            }
            return service;
          },
          inject: [
            RequestContextService,
            HTTP_CLIENT_FACTORY,
            PluginLoaderService,
            TemplateEngineService,
            TelemetryService,
            CAPABILITY_OPTIONS,
          ],
        },
        PluginLoaderService,
        TemplateEngineService,
        TelemetryService,
      ],
      exports: [CapabilityService, TelemetryService],
    };
  }
}
